// extracted by css-extract-rspack-plugin
export default {"titleLoadingSkeleton":"HeaderLoading-module__titleLoadingSkeleton__z76UhLe","metadataLoadingSkeleton":"HeaderLoading-module__metadataLoadingSkeleton__eLNX5Gz"};